import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import QuoteSquirkle from "images/quote-squerkle.svg"
import SparkleSquirkle from "images/sparkle-squirkle.svg"
import ContentWidth from "./ContentWidth"
import StyledLink from "components/StyledLink"

const Testimonial = ({ content }) => {
  return (
    <ContentWidth>
      <Wrapper bg={content?.mode}>
        {content?.image ? (
          <FlexContentContainer>
            <ContentContainer textColor={content?.mode}>
              <Eyebrow>TESTIMONIAL</Eyebrow>
              <Quote split={content?.asideImage}>{content.quoteBody}</Quote>
              <InfoDiv>
                <PersonQuoted>{content?.name}</PersonQuoted>
                <CompanyAndTitle>{content?.companyAndTitle}</CompanyAndTitle>
                <Location>{content?.location}</Location>
              </InfoDiv>
            </ContentContainer>
            <CompanyImage
              src={content?.image.sourceUrl}
              alt={content?.image?.altText}
            />
            {content?.ctaLink && (
              <StyledLink href={content?.ctaLink}>
                {content?.ctaText}
              </StyledLink>
            )}
          </FlexContentContainer>
        ) : (
          <ContentContainer textColor={content?.mode}>
            <Eyebrow>TESTIMONIAL</Eyebrow>
            <Quote large={content?.largeQuote}>{content.quoteBody}</Quote>
            <InfoDiv>
              {content?.name && <PersonQuoted>{content?.name}</PersonQuoted>}
              {content?.companyAndTitle && (
                <CompanyAndTitle>{content?.companyAndTitle}</CompanyAndTitle>
              )}
              {content?.location && <Location>{content?.location}</Location>}
            </InfoDiv>
            {content?.ctaLink && (
              <StyledLink href={content?.ctaLink}>
                {content?.ctaText}
              </StyledLink>
            )}
          </ContentContainer>
        )}
        {content?.asideImage ? (
          <DesignImage
            alt={content?.asideImage?.altText}
            src={SparkleSquirkle}
          />
        ) : (
          <DesignImage alt={content?.asideImage?.altText} src={QuoteSquirkle} />
        )}
      </Wrapper>
    </ContentWidth>
  )
}

const Wrapper = styled.div`
  background: ${props =>
    props.bg === "dark"
      ? colors.darkPurpleGradient
      : colors.lightPurpleGradient};
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 1.667vw;
  padding: 80px 184px 80px 68px;
  gap: 3.333vw;
  width: 88.889vw;

  ${media.fullWidth} {
    border-radius: 24px;
    padding: 80px 184px 80px 68px;
    gap: 48px;
    width: 1280px;
  }
  ${media.tablet} {
    border-radius: 2.344vw;
    padding: 5.859vw 11.719vw 5.859vw 3.809vw;
    gap: 4.688vw;
    width: 94.727vw;
  }
  ${media.mobile} {
    width: 87.85vw;
    gap: 10.28vw;
    padding: 9.346vw 4.206vw 14.019vw 4.673vw;
    border-radius: 5.607vw;
  }
`
const FlexContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: ${props =>
    props.textColor === "dark" ? colors.white : colors.grey800};
  gap: 4.861vw;

  ${media.fullWidth} {
    gap: 70px;
  }
  ${media.tablet} {
    gap: 4.883vw;
  }
  ${media.mobile} {
    flex-direction: column-reverse;
    gap: 9.346vw;
  }
`
const Eyebrow = styled.p`
  ${text.eyebrow};
`
const CompanyImage = styled.img`
  width: 28.056vw;
  z-index: 30;

  ${media.fullWidth} {
    width: 404px;
  }
  ${media.tablet} {
    width: 39.453vw;
  }
  ${media.mobile} {
    width: 77.85vw;
  }
`

const DesignImage = styled.img`
  width: 23.542vw;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 0;

  ${media.fullWidth} {
    width: 339px;
  }
  ${media.tablet} {
    width: 25vw;
  }
  ${media.mobile} {
    width: 33.178vw;
  }
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props =>
    props.textColor === "dark" ? colors.white : colors.grey800};
  gap: 1.389vw;

  ${media.fullWidth} {
    gap: 20px;
  }
  ${media.tablet} {
    gap: 1.953vw;
  }
  ${media.mobile} {
    gap: 4.673vw;
  }
`
const Quote = styled.blockquote`
  ${text.h3};
  width: ${props => (props.split ? "47.222vw" : "66.528vw")};
  z-index: 5;
  text-indent: -0.972vw;

  ${media.fullWidth} {
    width: ${props => (props.split ? "680px" : "958px")};
    text-indent: -14px;
  }
  ${media.tablet} {
    width: ${props => (props.split ? "42.969vw" : "69.199vw")};
    text-indent: -2.063vw;
  }
  ${media.mobile} {
    ${text.h3};
    width: ${props => (props.split ? "74.916vw" : "74.383vw")};
    text-indent: -3.271vw;
  }
`
const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5vw;

  ${media.fullWidth} {
    margin-top: 72px;
  }
  ${media.tablet} {
    margin-top: 9.766vw;
  }
  ${media.mobile} {
    margin-top: 14.019vw;
  }
`
const PersonQuoted = styled.p`
  ${text.bodyMdBold};
`
const CompanyAndTitle = styled.p`
  ${text.bodyMd};
`
const Location = styled.p`
  ${text.bodyMd};
`
export default Testimonial
